<template>
    <div class="help-pane"
         v-if="$store.state.translationsLoaded && helpText">

        <b-button v-b-toggle.help-sidebar class="help-pane__button">
            <b-icon-question-circle/>
        </b-button>
        <b-sidebar right
                   id="help-sidebar"
                   class="help-pane__content"
                   title="Help">
            <div class="px-3 py-2 sidebar-content">
                <div v-html="helpText"/>
            </div>
        </b-sidebar>

    </div>
</template>

<script>

import Vue from 'vue'

/**
 * Renders a help button on the page, which activates a Help sidebar with content
 * specified via a translation key in the route meta configuration
 */
export default Vue.extend({
    name: 'HelpPane',
    computed: {
        helpKey () {
            const key = this.$route.meta.help
            if (key === 'HOME') {
                if (this.$user.roleIs('ADMIN')) {
                    return 'HOME_ADMIN'
                } else if (this.$user.roleIs('PARTICIPANT')) {
                    return 'HOME_PARTICIPANT'
                } else if (this.$user.roleIs('PRACTITIONER')) {
                    return 'HOME_PRACTITIONER'
                } else {
                    //if (this.$user.noLoggedInUser())
                    return 'HOME_ANONYMOUS'
                }
            } else {
                return key
            }
        },
        helpText () {
            const key = this.helpKey
            if (key) {
                return key
            } else {
                return null
            }
        }
    }
})
</script>

<style lang="scss">

.content-outer {
    padding-bottom: 3em;
}

.help-pane {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 2;


    .btn {
        border-radius: 5px 0 0 0;
        position: absolute;
        right: 0;
        bottom: 0;
        padding: 8px;

        &:active, &:focus {
            background-color: var(base-color);
        }

        svg {
            font-size: 30px !important;
        }
    }

    .sidebar-content {
        height: 100%;
        overflow-y: scroll;
    }

    button.close {
        border: solid 1px var(--blue-lighten-30);
        background-color: #fff;
        padding: 3px;
        border-radius: 50%;
        cursor: pointer;
        opacity: 1;

        svg {
            color: var(--blue-lighten-30);
        }

        &:hover {
            background-color: var(--btn-bg-hover);
            border-color: var(--btn-bg-hover);
            opacity: 1 !important;

            svg {
                color: #fff !important;
            }
        }
    }
}

#help-sidebar {
    box-shadow: 0 0 20px rgba(0, 0, 0, .1);
    border-left: solid 1px var(--border-color);
    //background-color: #D6F2FF!important;
    background-color: var(--accent-color-lighten-40) !important;
}

</style>
